export const CURRENCY_TO_COUNTRY_MAP: Record<string, string> = {
  USD: 'us',
  CAD: 'ca',
  DOP: 'do',
  MXN: 'mx',
  EUR: 'eu',
  GBP: 'gb',
  AUD: 'au',
  ZAR: 'za',
  SEK: 'se',
};

export const getCurrencyCountryCode = (currencyCode: string): string => {
  const upperCaseCurrency = currencyCode.toUpperCase();
  return CURRENCY_TO_COUNTRY_MAP[upperCaseCurrency] || 'us';
};
